import * as React from 'react';
import Button from '@mui/material/Button';
import {
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Typography,
  Link,
  Box,
  FormControl,
  Stack,
  Container,
  OutlinedInput,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import ChaplaincyImage from 'images/ChaplaincyLogin.png';
import { useTranslation } from 'react-i18next';
import { StringMap, TOptions } from 'i18next';
import { useNavigate } from 'react-router-dom';

export type i18translateType = {
  t: (
    key: string | TemplateStringsArray | (string | TemplateStringsArray)[],
    options?: string | TOptions<StringMap> | undefined,
  ) => string;
};

export default function Chaplin() {
  const navigate = useNavigate();
  const { t }: i18translateType = useTranslation();
  const [userName, setUserName] = React.useState('admin');
  const [emailErrorMsg, setEmailErrorMsg] = React.useState('');
  const [password, setPassword] = React.useState('admin');
  const [passwordErrorMsg, setPasswordErrorMsg] = React.useState('');

  const handleLoginForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };
  const login = () => {
    if (userName === '' && password === '') {
      setEmailErrorMsg('usename should not be empty');
      setPasswordErrorMsg('Password should not be em empty');
    } else if (userName !== '' && password === '') {
      setEmailErrorMsg('');
      setPasswordErrorMsg('Password should not be em empty');
    } else if (userName === '' && password !== '') {
      setEmailErrorMsg('usename should not be em empty');
      setPasswordErrorMsg('');
    } else if (userName !== 'admin' && password !== '') {
      setEmailErrorMsg('please use username as: admin');
      setPasswordErrorMsg('');
    } else if (userName !== '' && password !== 'admin') {
      setEmailErrorMsg('');
      setPasswordErrorMsg('Please use password as: admin');
    } else if (userName === 'admin' && password === 'admin') {
      setEmailErrorMsg('');
      setPasswordErrorMsg('');
      navigate('/chaplindetails');
    }
  };

  return (
    <Container sx={{ py: 8, maxHeight: '100%' }} maxWidth='sm'>
      <Card sx={{ maxWidth: 405, boxShadow: 4 }}>
        <CardContent>
          <Box component='form' onSubmit={handleLoginForm} noValidate sx={{ mt: 1 }}>
            <Stack
              direction='column'
              justifyContent='space-between'
              alignItems='center'
              spacing={2}
            >
              <img src={ChaplaincyImage} style={{ maxWidth: '100%', height: '150px' }} />
              <Typography variant='h6' sx={{ fontWeight: 'bold' }} gutterBottom>
                {t('chapLogin', { ns: ['home'] })}
              </Typography>
              <Typography variant='h6' sx={{ fontWeight: 'bold' }} gutterBottom>
                {t('administrationAdminUserBanner', { ns: ['home'] })}
              </Typography>
              <Grid container direction='row' justifyContent='flex-start' alignItems='flex-start'>
                <Grid item>
                  <Box>{t('administrationAdminUserName', { ns: ['home'] })}</Box>
                </Grid>
              </Grid>
              <FormControl variant='outlined' fullWidth>
                <OutlinedInput
                  id='input-with-icon-adornment'
                  size='small'
                  type='text'
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  sx={{
                    padding: '0px',
                    height: '34px',
                    margin: '0px',
                  }}
                  startAdornment={
                    <InputAdornment
                      sx={{
                        width: '50px',
                        height: '40px',
                        paddingLeft: '10px',
                      }}
                      position='start'
                    >
                      <AccountCircle />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='flex-start'
              >
                <Grid item>
                  {emailErrorMsg !== '' ? (
                    <Typography style={{ color: '#d32f2f' }} sx={{ fontSize: 14 }}>
                      {emailErrorMsg}
                    </Typography>
                  ) : null}
                </Grid>
              </Grid>
              <Grid container direction='row' justifyContent='flex-start' alignItems='flex-start'>
                <Grid item>
                  <Box>{t('administrationAdminPassword', { ns: ['home'] })}</Box>
                </Grid>
              </Grid>
              <FormControl variant='outlined' fullWidth>
                <OutlinedInput
                  id='input-with-icon-adornment'
                  size='small'
                  type='password'
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  sx={{
                    padding: '0px',
                    height: '34px',
                    margin: '0px',
                  }}
                  startAdornment={
                    <InputAdornment
                      sx={{
                        width: '50px',
                        height: '40px',
                        paddingLeft: '10px',
                      }}
                      position='start'
                    >
                      <LockIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='flex-start'
              >
                <Grid item>
                  {passwordErrorMsg !== '' ? (
                    <Typography style={{ color: '#d32f2f' }} sx={{ fontSize: 13 }}>
                      {passwordErrorMsg}
                    </Typography>
                  ) : null}
                </Grid>
              </Grid>
              <Grid container direction='row' justifyContent='flex-end' alignItems='flex-start'>
                <Grid item>
                  <Link href='/forgotten-password' underline='always'>
                    {t('administrationAdminForgotPassword', { ns: ['home'] })}
                  </Link>
                </Grid>
              </Grid>
              <Button
                type='submit'
                fullWidth
                variant='contained'
                size='large'
                onClick={() => login()}
              >
                <Stack direction='row' spacing={1}>
                  <Typography>{t('administrationAdminButton', { ns: ['home'] })}</Typography>
                </Stack>
              </Button>
            </Stack>
          </Box>
        </CardContent>
      </Card>
      <Grid container direction='row' justifyContent='flex-start' alignItems='center' pt={8}>
        <Grid item>
          <Typography variant='subtitle1' >
            {t('login', { ns: ['home'] })}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
